import script from "./ValidatorsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorsTable.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorsTable.vue?vue&type=style&index=0&id=073cc1d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073cc1d4"]])

export default __exports__